import { debounce } from "lodash";

export const redirectSignUpFlow = debounce(
  function (documentoCrip, filhos, instagram, history, location) {
    if (!documentoCrip) {
      if (location.pathname !== "/cadastre-se/passo-1/dados-pessoais") {
        history.push({
          pathname: "/cadastre-se/passo-1/dados-pessoais"
        });
      }
    } else if (!filhos?.NomeFilho?.trim()) {
      if (location.pathname !== "/cadastre-se/passo-1/bebe") {
        history.push({
          pathname: "/cadastre-se/passo-1/bebe"
        });
      }
    } else if (!instagram) {
      if (location.pathname !== "/cadastre-se/passo-1/dados-contato") {
        history.push({
          pathname: "/cadastre-se/passo-1/dados-contato"
        });
      }
    } else {
      if (location.pathname !== "/minha-conta") {
        history.push({
          pathname: "/minha-conta"
        });
      }
    }
  },
  500
);